import { Button, Card, Icon } from '@iwoca/orion';
import { useAmplitude } from 'hooks/useAmplitude';
import { TWhatsNewNotification } from 'lendingApi/whatsNew';
import Markdown from 'react-markdown';
import { useNavigate } from 'react-router-dom';
import rehypeRaw from 'rehype-raw';
import remarkGfm from 'remark-gfm';
import { PATH_NAMES } from 'utils/routes/pathNames';
import { AMPLITUDE_EVENTS } from 'utils/tracking/tracking.events';
import styles from './Popup.module.css';

type TProps = {
  notification: TWhatsNewNotification;
  onCloseClick: () => void;
};

export const Popup = ({ notification, onCloseClick }: TProps) => {
  const navigate = useNavigate();
  const { trackEvent } = useAmplitude();

  const onClose = () => {
    trackEvent(AMPLITUDE_EVENTS.CTAClicked, {
      'CTA type': 'Button',
      'CTA text': '',
      category: `Close What's New popup`,
    });
    onCloseClick();
  };

  const onCardClick = () => {
    trackEvent(AMPLITUDE_EVENTS.CTAClicked, {
      'CTA type': 'Card',
      'CTA text': '',
      category: `What's New popup`,
    });

    navigate(PATH_NAMES.whatsNew());
    onCloseClick();
  };

  return (
    <Card className={styles.card} onClick={onCardClick}>
      <div className={styles.content}>
        <div className={styles.text}>
          <div className={styles.header}>
            <h2 className={styles.heading}>{notification.title}</h2>
            <Button
              iconOnly
              variant="tertiary"
              size="small"
              onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
                e.stopPropagation();
                onClose();
              }}
              data-testid="popup-close-button"
            >
              <Icon icon="timesDefault" />
            </Button>
          </div>
          <Markdown
            className={styles.markdown}
            remarkPlugins={[remarkGfm]}
            rehypePlugins={[rehypeRaw]}
          >
            {notification.text}
          </Markdown>
        </div>
      </div>
    </Card>
  );
};
